import { ETransportAccessibilityTab } from '../../../types/map';

const MAPPING: Record<string, string> = {
  [ETransportAccessibilityTab.Outside]: 'accessibility_near_jk',
  [ETransportAccessibilityTab.Inside]: 'accessibility_inside_jk',
};

export const getAnalyticsTabName = (tab: string) => MAPPING[tab];
